"use strict";
require.context("../../images", true);
import "src/decidim/data_consent/iframe_consent_exemptions";
